import { defineAsyncComponent as lazyLoad } from "vue";

export class Components {
  static Agenda(): any {
    return lazyLoad(() => import("./Agenda/index.vue"));
  }
  static Banner(): any {
    return lazyLoad(() => import("./Banner/banner.vue"));
  }

  static Breadcrumb(): any {
    return lazyLoad(() => import("./Breadcrumb/breadcrumb.vue"));
  }

  static CardCourse(): any {
    return lazyLoad(() => import("./Card/card-course.vue"));
  }

  static Card(): any {
    return lazyLoad(() => import("./Card/card.vue"));
  }

  static Dropzone(): any {
    return lazyLoad(() => import("./Dropzone/dropzone.vue"));
  }

  static EmptyData(): any {
    return lazyLoad(() => import("./EmptyData/empty-data.vue"));
  }

  static Errors(): any {
    return lazyLoad(() => import("./Errors/errors.vue"));
  }

  static Footer(): any {
    return lazyLoad(() => import("./Footer/footer.vue"));
  }

  static Loader(): any {
    return lazyLoad(() => import("./Loader/loader.vue"));
  }

  static Logo(): any {
    return lazyLoad(() => import("./Logo/logo.vue"));
  }

  static MaterialLoad(): any {
    return lazyLoad(() => import("./Material/material.vue"));
  }

  static MessageVoice(): any {
    return lazyLoad(() => import("./MessageVoice/message-voice.vue"));
  }

  static PDFComponent(): any {
    return lazyLoad(() => import("./PDFComponent/pdf-component.vue"));
  }

  static TableFilter(): any {
    return lazyLoad(() => import("./Table/filter-table.vue"));
  }

  static Topbar(): any {
    return lazyLoad(() => import("./Topbar/topbar.vue"));
  }

  static TopbarCourse(): any {
    return lazyLoad(() => import("./TopbarCourse/topbar-course.vue"));
  }

  static Video(): any {
    return lazyLoad(() => import("./VideoPlayer/video-player.vue"));
  }

  static CountDown(): any {
    return lazyLoad(() => import("@chenfengyuan/vue-countdown"));
  }

  static Speech(): any {
    return lazyLoad(() => import("./SpeechRecognition/speech.vue"));
  }

  static Record(): any {
    return lazyLoad(() => import("./RecordStream/record-stream.vue"));
  }

  static Attention(): any {
    return lazyLoad(() => import("./Attention/attention.vue"));
  }

  static LearningMapTeacher(): any {
    return lazyLoad(
      () => import("./LearningMap/LearningMapTeacher/learning-map-teacher.vue")
    );
  }

  static LearningMap(): any {
    return lazyLoad(() => import("./LearningMap/learning-map.vue"));
  }

  static InfiniteScroll(): any {
    return lazyLoad(() => import("./InfiniteScroll/infinite-scroll.vue"));
  }

  static TagMaterials(): any {
    return lazyLoad(() => import("./TagMaterials/tag-materials.vue"));
  }

  static ModalPermissionBrowser(): any {
    return lazyLoad(
      () => import("./Modals/PermissionBrowser/modal-permission-browser.vue")
    );
  }

  static MaterialModal(): any {
    return lazyLoad(() => import("./Modals/Material/material-modal.vue"));
  }

  static FullModal(): any {
    return lazyLoad(() => import("./Modals/FullModal/full-modal.vue"));
  }

  static LimitTimeModal(): any {
    return lazyLoad(
      () => import("./Modals/LimitTimeModal/limit-time-modal.vue")
    );
  }

  static CourseLearningMapStudent(): any {
    return lazyLoad(
      () =>
        import(
          "./LearningMap/CourseLearningMapStudent/course-learning-map-student.vue"
        )
    );
  }

  static ImportCSV(): any {
    return lazyLoad(() => import("./ImportCSV/import-csv.vue"));
  }

  static ListObjective(): any {
    return lazyLoad(() => import("./ListObjective/list-objective.vue"));
  }

  static ProgressCircleMaterial(): any {
    return lazyLoad(
      () => import("./ProgressCircleMaterial/progress-circle-material.vue")
    );
  }

  static OrderButtons(): any {
    return lazyLoad(() => import("./OrderButtons/index.vue"));
  }

  static TipTap(): any {
    return lazyLoad(() => import("./TipTap/index.vue"));
  }

  static MagicSvg(): any {
    return lazyLoad(() => import("./MagicSvg/index.vue"));
  }

  static H5PComponent(): any {
    return lazyLoad(() => import("./H5PComponent/index.vue"));
  }
}
